/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Wallet from '../../../../components/wallet';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { currenciesDefault } from '../../../../utilities/constants';

const Wallets = ({
  wallets,
  mainScreen,
  openScreen,
  updateCalculatorForm,
  isPayoutWallet,
  calculatorForm,
  useableWallets,
  setCurrentWallet,
}) => {
  const { t: translate } = useTranslation();
  const [searchValue, setSearchValue] = useState('');
  const [renderedWallets, setRenderedWallets] = useState(wallets);

  const handleSearchInput = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    if (searchValue) {
      const safeSearchValue = searchValue.trim().toLowerCase();
      const filterWallets = wallets.filter(
        (wallet) =>
          wallet?.coin?.trim().toLowerCase().includes(safeSearchValue) ||
          wallet?.currency_code?.trim().toLowerCase().includes(safeSearchValue) ||
          wallet?.currency_name?.trim().toLowerCase().includes(safeSearchValue) ||
          currenciesDefault[wallet?.coin?.toUpperCase()]?.fullName
            ?.toLowerCase()
            .includes(safeSearchValue)
      );
      setRenderedWallets(filterWallets);
    } else {
      setRenderedWallets(wallets);
    }
  }, [searchValue, wallets]);

  const chooseWallet = (data) => {
    if (isPayoutWallet) {
      updateCalculatorForm({ ...calculatorForm, principalWallet: data });
    } else {
      updateCalculatorForm({ ...calculatorForm, collateralWallet: data });
    }
    setCurrentWallet(data);
    openScreen(mainScreen);
  };

  // const renderFooterHardWallet = () => (
  //   <button
  //     type="button"
  //     className="btn text-white border border-shadow text-shadow mt-4 py-3 modal__footer-btn"
  //     onClick={() => {
  //       // TODO: using LEDGER hardware wallet
  //     }}>
  //     {translate('use_ledger_hardware_wallet_btn_label')}
  //   </button>
  // );

  return (
    <ModalBodyLayout
      title={
        isPayoutWallet
          ? translate('loan_payout_wallets_title')
          : translate('loan_source_wallets_title')
      }
      onPrevClick={() => openScreen(mainScreen)}
      withBack>
      <div className="my-3">
        <div
          className="rounded bg-light p-0 popup-search-input d-flex flex-row flex-row-reverse position-relative"
          style={{ height: '3rem' }}>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => handleSearchInput(e)}
            className="form-control border-0 bg-light shadow-none w-100 ps-5 d-flex"
            placeholder={translate('select_account_input_placeholder')}
          />
          <i className="position-absolute start-0 top-0 px-3 py-3 icon icon-search-other h-100 d-flex align-items-center justify-content-center text-shadow" />
          <i
            onClick={() => {
              setSearchValue('');
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
            label="close"
            hidden={searchValue === '' || searchValue === null || searchValue === undefined}
            className="icon icon-close-other text-white position-absolute top-50 end-0 translate-middle-y pe-3"
          />
        </div>
      </div>
      <div style={{ overflowY: 'auto', maxHeight: '30rem' }}>
        {renderedWallets.map((item) => (
          <Wallet
            key={item.id}
            data={item}
            openScreen={openScreen}
            chooseWallet={chooseWallet}
            mainScreen={mainScreen}
            useableWallets={useableWallets}
          />
        ))}

        {renderedWallets && renderedWallets.length === 0 && (
          <div
            style={{ height: '29rem' }}
            className="d-flex flex-column justify-content-center align-content-center">
            <h2 className="text-center">{translate('search_no_results_found_label')}</h2>
            <p className="text-shadow text-center">
              {translate('search_no_results_found_sublabel')}
            </p>
          </div>
        )}
      </div>
    </ModalBodyLayout>
  );
};

export default Wallets;

Wallets.propTypes = {
  wallets: PropTypes.array.isRequired,
  openScreen: PropTypes.func.isRequired,
  updateCalculatorForm: PropTypes.func.isRequired,
  mainScreen: PropTypes.string.isRequired,
  isPayoutWallet: PropTypes.bool.isRequired,
  calculatorForm: PropTypes.object.isRequired,
  useableWallets: PropTypes.array.isRequired,
  setCurrentWallet: PropTypes.func,
};

Wallets.defaultProps = {
  setCurrentWallet: () => {},
};
